<script>
import TwSelectDropdown from '@/components/generic/tw-select-dropdown.vue'
import TwButton from '@/components/generic/tw-button.vue'

export default {
  name: 'TwTabsNavigation' ,
  components: { TwButton, TwSelectDropdown },
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: String,
      default: null
    },
    idField: {
      type: String,
      default: 'id'
    }
  },
  emits: ['update:modelValue'],
}
</script>

<template>
  <div class="">
    <nav class="flex flex-row gap-5 font-sans items-center" aria-label="Tabs">
      <template v-for="tab in tabs">
        <span v-if="tab[idField] === modelValue" :key="'span-' + tab.name" class="font-semibold text-sm">
          {{ tab.name }} <span v-if="tab.badge">({{ tab.badge }})</span>
        </span>
        <tw-button v-else :key="tab.name" size="sm" variant="secondary" :aria-current="tab[idField] === modelValue ? 'page' : undefined" @click="$emit('update:modelValue', tab[idField])">
          {{ tab.name }} <span v-if="tab.badge">({{ tab.badge }})</span>
        </tw-button>
      </template>
    </nav>
  </div>
</template>

<style scoped>

</style>
